import {
  DealParticipantStatisticsRequest,
  DealParticipantStatisticsResponse,
  ProcessingCountersRequest,
  ProcessingCountersResponse,
  ProcessingListRequest,
  ProcessingListResponse,
} from '@common/model/processing';
import { coreApi } from '@cp/shared/api/core';
import { AdminProcessingApiTag, adminProcessingApiTags } from './tags';

export const adminProcessingApi = coreApi
  .enhanceEndpoints({
    addTagTypes: adminProcessingApiTags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      markAsProcessed: builder.mutation<null, string>({
        query: (id) => ({
          url: `admin/processing/${id}/processed`,
          method: 'POST',
        }),
      }),
      getProcessingList: builder.query<ProcessingListResponse, ProcessingListRequest>({
        query: (params) => ({
          url: 'admin/processing',
          params,
        }),
      }),
      getProcessingCounters: builder.query<ProcessingCountersResponse, ProcessingCountersRequest | void | null | false>({
        query: (params) => ({
          url: 'admin/processing/counters',
          params,
        }),
        providesTags: [AdminProcessingApiTag.Counters],
      }),
      getProcessingStatistics: builder.query<DealParticipantStatisticsResponse, DealParticipantStatisticsRequest>({
        query: (params) => ({
          url: 'admin/processing/statistics',
          params,
        }),
      }),
    }),
  });

export { AdminProcessingApiTag, adminProcessingApiTags } from './tags';
